import { put, takeLatest,call,spawn, all } from 'redux-saga/effects';
import { coverageActions } from '../../../application/actions/coverage';

import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiCoverage = api(process.env.REACT_APP_COVERAGE_API);

export function* fetchCoverage(action) {
  /* istanbul ignore next */
  const tokenProcess = sessionStorage.getItem('token') || action.payload.tokenProcess;
  /* istanbul ignore next */
  if (!tokenProcess) {
    throw new Error('Token de proceso no encontrado');
  }
  /* istanbul ignore next */
   const headers = {
    Authorization: `${tokenProcess}`,
  }; 


  try {
    yield put(loadingActions.changeStatusLoadingFetchCoverage({ isLoading: true }));
     const { typeAddress, ...newPayload } = action.payload;
    const response =  yield call(apiCoverage.post, 'v1/consultar', newPayload,headers);
     /* istanbul ignore next */
    
    const { data } = response;
    /* istanbul ignore next */
    if (data)
      yield all([
        put(loadingActions.changeStatusLoadingFetchCoverage({ isLoading: false })),
        put(
          coverageActions.fetchCoverageSuccess({ ...data, typeAddress: action.payload.typeAddress })
        ),
      ]);
    else
      yield all([
        put(loadingActions.changeStatusLoadingFetchCoverage({ isLoading: false })),
        put(
          coverageActions.fetchCoverageError({
            ...response.error,
            typeAddress: action.payload.typeAddress,
          })
        ),
      ]);
  } catch (err) {
    console.error('coverage saga error:', err);
    yield all([
      put(
        coverageActions.fetchCoverageError({ code: 500, typeAddress: action.payload.typeAddress })
      ),
      put(loadingActions.changeStatusLoadingFetchCoverage({ isLoading: false })),
    ]);
  }
}
/* istanbul ignore next */
export function* watchFetchCoverage() {
  yield takeLatest(coverageActions.fetchCoverage.type, fetchCoverage);
}
/* istanbul ignore next */
export default function* coverageSaga() {
  yield spawn(watchFetchCoverage);
}
